export default "__VITE_ASSET__CqhcTkvY__"